import React from "react";
import { ErrorMOdalWrapper } from "./styles";
import ErrorModal from "../../../../../common/callback/modal/error/ErrorModal";
import Modal from "../../../../../../shared/modal/modal";

function Error({ close = null, errorMessage = "error" }) {
  return (
    <ErrorMOdalWrapper>
      <Modal
        type={"authError"}
        shown={errorMessage}
        close={close}
        error={errorMessage}
      />
    </ErrorMOdalWrapper>
  );
}

export default Error;
